import { memo, type FunctionComponent } from 'react';
import map from 'lodash/map';
import size from 'lodash/size';
import round from 'lodash/round';
import { FormattedMessage } from 'react-intl';
// Skillmore UI Components
import BoxTypography from '@empathco/ui-components/src/mixins/BoxTypography';
import GridBox from '@empathco/ui-components/src/mixins/GridBox';
import StandardLink from '@empathco/ui-components/src/elements/StandardLink';
// local imports
import { OtherResource } from '../config/customer';

const values = { br: <br/> };

type ExploreOtherResourcesSectionProps = {
  readonly title: string;
  readonly isInternational?: boolean;
  readonly vertical?: boolean;
  readonly resources?: OtherResource[] | null;
};

const ExploreOtherResourcesSection: FunctionComponent<ExploreOtherResourcesSectionProps> = ({
  title,
  isInternational = false,
  vertical = false,
  resources
}) => (
  <>
    <BoxTypography
        px={vertical ? 7 : 6}
        variant="h3"
        textAlign={vertical ? undefined : 'center'}
    >
      <FormattedMessage id={title}/>
    </BoxTypography>
    <GridBox
        container
        py={3.5}
        px={4}
    >
      {map(resources, ({ text, link, intl }, index) => (
        <GridBox
            key={index}
            size={{
              xs: 12,
              sm: vertical ? undefined : 6,
              md: vertical ? undefined : round(12 / size(resources))
            }}
            container
            justifyContent={vertical ? undefined : 'center'}
            px={3}
            py={1.5}
        >
          <StandardLink
              active
              variant="h4"
              text={isInternational && intl ? intl.text : text}
              link={isInternational && intl ? intl.link : link}
              values={values}
          />
        </GridBox>
      ))}
    </GridBox>
  </>
);

export default memo(ExploreOtherResourcesSection);
